import { usePost } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useCandidateAttachFile = () => {
  return usePost({ url: ApiRoutesEnum.candidateAttachFile });
};
